import React from "react";
import styled from "styled-components";
import "./preloader.css";

const LoadingData = styled.div`
  background: linear-gradient(#ffffff,#e8e8e8);
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &.pointer-events-none {
    pointer-events: none;
  }
`;

const Loader = () => {
  return (
    <LoadingData
      id="preloader"
    >
      <div
        className="aniamte__animated animate__bounceIn"
      >
        <div className="boxes">
          <div className="box">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div className="box">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div className="box">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div className="box">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </LoadingData>
  );
};

export default Loader
